// Path-based tree helpers shared by every recursive and/or/not condition
// editor in the app (functionality_control for CONF 2.0/3.0, and LIN rule
// conditions for CONF 3.0). A "path" is the sequence of and/or child indices
// from a tree's root down to a given node. Unlike matching nodes by object
// reference, a path can't silently fail to find its target when a
// differently-instanced-but-equal `{}` placeholder ends up mounted in place
// of the "real" node - it always addresses the correct position directly.
export type Path = number[];

export const childArrayKey = (node: any): 'and' | 'or' => (node.and ? 'and' : 'or');

export const setAtPath = (root: any, path: Path, updater: (node: any) => any): any => {
    if (path.length === 0) return updater(root);
    const [index, ...rest] = path;
    const key = childArrayKey(root);
    return {
        ...root,
        [key]: root[key].map((child: any, i: number) => (i === index ? setAtPath(child, rest, updater) : child)),
    };
};

export const deleteAtPath = (root: any, path: Path): any => {
    const [index, ...rest] = path;
    const key = childArrayKey(root);
    if (rest.length === 0) {
        return { ...root, [key]: root[key].filter((_: any, i: number) => i !== index) };
    }
    return {
        ...root,
        [key]: root[key].map((child: any, i: number) => (i === index ? deleteAtPath(child, rest) : child)),
    };
};
